import './Wishes.css';

const Wishes = () => {
  return (
    <section className="wishes" id="пожелания">
      <div className="wishes__overlay" />
      <h2 className="wishes__title">ПОЖЕЛАНИЯ</h2>
      <p className="wishes__text">
        Ваше присутствие — самый дорогой для нас подарок.{' '}
        <br className="wishes__break" />
        Если вы захотите сделать вклад, он станет частью нашего свадебного фонда для будущего путешествия
      </p>
    </section>
  );
};

export default Wishes;
